import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { ArrowRight } from 'lucide-react';
import CustomButton from './Buttons';

const LocationCustomCard = ({
    image,
    title,
    subtitleI,
    subtitleII,
    subtitleIII,
    onClick,
    direction = 'rtl',
    buttonTitle = "",
    buttonClassName = "",
    clickFun = () => { }
}) => {
    const theme = useTheme();

    return (
        <Card
            sx={{ boxShadow: "none", borderRadius: "10px" }}
            className="border-2 cursor-pointer"
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: direction === "rtl" ? "row-reverse" : "row",
                }}
                onClick={onClick}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '60%', }} className="py-3">
                    <CardContent sx={{ flex: '1 0 auto' }}>
                        <div className='flex gap-2 text-lg font-bold text-gray-900 mb-1'>
                            {title} <ArrowRight />
                        </div>
                        <div className='text-sm font-medium text-gray-500'>
                            {subtitleI}
                        </div>
                        <div className='text-sm font-medium text-gray-500'>
                            {subtitleII}
                        </div>
                        <div className='text-sm font-medium text-gray-500'>
                            {subtitleIII}
                        </div>
                    </CardContent>
                </Box>
                <CardMedia
                    component="img"
                    sx={{ width: 151, width: "40%" }}
                    image={image}
                    alt={`${title} album cover`}
                />
            </Box>
            <div className="w-full flex justify-center px-6 py-4 border-t">
                <CustomButton
                    type="button"
                    className={buttonClassName}
                    click={() => {
                        clickFun();
                    }}
                    text={buttonTitle}
                />
            </div>
        </Card>
    );
};

export default LocationCustomCard;
